package org.example.project.service

import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import org.example.project.utils.All

object KundenverbrauchService {

    private const val AUTO_ONBOARDING_MARKER = "AUTO_ONBOARDING_SETUP"
    private const val AUTO_LIZENZ_MARKER = "AUTO_LIZENZ_AKTIV"
    private const val AUTO_SUPPORT_MARKER_PREFIX = "AUTO_SUPPORT_TICKET:"

    private fun currentMonthKey(): String {
        val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
        return "${now.year}_${now.monthNumber.toString().padStart(2, '0')}"
    }

    private fun currentDate(): String =
        Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date.toString()

    private fun resolveNetzwerkKey(kunde: All): String =
        kunde.firmenId

    fun storageIdForEntry(entry: All): String = when {
        entry.notiz == AUTO_ONBOARDING_MARKER -> "onboarding"
        entry.notiz == AUTO_LIZENZ_MARKER -> "lizenzierung"
        entry.notiz.startsWith(AUTO_SUPPORT_MARKER_PREFIX) -> {
            val ticketId = entry.notiz.removePrefix(AUTO_SUPPORT_MARKER_PREFIX).trim()
            if (ticketId.isBlank()) entry.id else "support_$ticketId"
        }
        else -> entry.id
    }

    private suspend fun appendAutoEntry(kunde: All, marker: String, transform: (String, String, String) -> All) {
        val netzwerkKey = resolveNetzwerkKey(kunde)
        if (netzwerkKey.isBlank()) return

        val monthKey = currentMonthKey()
        val nextRow = transform(storageIdForEntry(All(notiz = marker)), currentDate(), netzwerkKey).copy(
            firmenId = netzwerkKey,
            firma = kunde.firma
        )

        CustomerApi.saveVerbrauchEntry(
            netzwerkKey,
            monthKey,
            storageIdForEntry(nextRow),
            nextRow
        )
    }

    suspend fun appendOnboardingOnInstall(kunde: All) {
        appendAutoEntry(kunde, AUTO_ONBOARDING_MARKER) { id, date, netzwerkKey ->
            All(
                id = id,
                firmenId = netzwerkKey,
                datum = date,
                einmalzahlung = "1",
                notiz = AUTO_ONBOARDING_MARKER
            )
        }
    }

    suspend fun appendLizenzierungOnAktiv(kunde: All) {
        appendAutoEntry(kunde, AUTO_LIZENZ_MARKER) { id, date, netzwerkKey ->
            All(
                id = id,
                firmenId = netzwerkKey,
                datum = date,
                lizenzMonatlich = "1",
                notiz = AUTO_LIZENZ_MARKER
            )
        }
    }

    suspend fun appendSupportTicket(ticket: All) {
        val netzwerkKey = ticket.firmenId
        if (netzwerkKey.isBlank() || ticket.id.isBlank()) return

        val monthKey = currentMonthKey()
        val marker = "$AUTO_SUPPORT_MARKER_PREFIX${ticket.id}"
        val nextRow = All(
            id = ticket.id,
            firmenId = netzwerkKey,
            firma = ticket.firma,
            datum = currentDate(),
            supportTicket = "1",
            notiz = marker
        )

        CustomerApi.saveVerbrauchEntry(
            netzwerkKey,
            monthKey,
            storageIdForEntry(nextRow),
            nextRow
        )
    }
}



